import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../../AnimationContents";


export interface ColliderOptions{
}

export class ColliderController extends AnimationBaseController{
    $model: any;

    constructor(
        @Inject private options: ColliderOptions
    ){
        super("ColliderController");
    }

    getConfiguration(): IAnimationControllerConfiguration{
        return{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: "colliders",
        }
    }

    onInitialize(){
        this.visible = false;
        this.alpha = 0.5;
    }
}